import React from 'react';
import Typography from '../../../../components/common/Typography';
import { IconButton } from '../../../../components/common/Button';

const ItemTitleSection = ({ title, handleDeleteButton, buttonIcon = true }) => {
  return (
    <div className="displayFlex" style={{ gap: '10px' }}>
      <Typography variant="body1Bold">{title}</Typography>
      <div className="titleLine"></div>
      {buttonIcon && (
        <IconButton
          deleteIcon
          variant="outline"
          size="small"
          color="gray"
          onClick={handleDeleteButton}
          alt={`${title} 삭제`}
        />
      )}
    </div>
  );
};

export default ItemTitleSection;
